export enum AuthType {
    DEFAULT,
    REVERSE,
}
